import { render, staticRenderFns } from "./DoneTask.vue?vue&type=template&id=be716700"
import script from "./DoneTask.vue?vue&type=script&lang=js"
export * from "./DoneTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports